import { useEffect, useEffectEvent } from "react";

import { useDispatch } from "@src/store";
import { ExperienceBuilderAction } from "@src/store/slices/experienceBuilder";
import { ExperienceBuilderMode } from "@src/store/slices/experienceBuilder/types";

const KEY_TO_MODE: Record<string, ExperienceBuilderMode> = {
  n: "navigate",
  s: "select",
};

export const useModeShortcuts = (enabled: boolean) => {
  const dispatch = useDispatch();

  const onKeyDown = useEffectEvent((event: KeyboardEvent) => {
    if (!enabled) return;
    if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) {
      return;
    }

    const target = event.target as HTMLElement;
    if (
      target.tagName === "INPUT" ||
      target.tagName === "TEXTAREA" ||
      target.isContentEditable
    ) {
      return;
    }

    const mode = KEY_TO_MODE[event.key.toLowerCase()];
    if (!mode) return;

    event.preventDefault();
    void dispatch(ExperienceBuilderAction.setMode(mode));
  });

  useEffect(() => {
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, []);
};
